var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import { TswagClient } from "./../commons/TswagClient";
import { PredefinedBankAccount } from "./../models/V1/BankAccounts/PredefinedBankAccount";
export class BankAccounts {
  /**
   * Creates an instance of BankAccounts.
   * @param {string} [baseUrl]
   * @param {{ fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }} [http]
   * @memberof BankAccounts
   */
  constructor(baseUrl, http) {
    __publicField(this, "http");
    __publicField(this, "baseUrl");
    this.baseUrl = baseUrl;
    this.http = http ? http : window;
  }
  /**
   * @param GetPredefinedBankAccountsRq_ _getPredefinedBankAccountsRq
   * @returns Promise<GetPredefinedBankAccountsRq_>
   * @memberof BankAccounts
   */
  getPredefinedBankAccounts(options = {}) {
    const client = new TswagClient(this.baseUrl + "/api/v1/BankAccounts", "GET", "application/json; charset=UTF-8", "text/plain, application/json, text/json", options);
    const respDescriptor = {
      headerParams: [],
      items: [{ statusCode: 200, clazz: PredefinedBankAccount, isArray: true }]
    };
    return client.fetch(this.http, respDescriptor);
  }
}
